import React from "react";

// Material UI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomActionBar from '../../../components/CustomActionBarDatePicker';
import dayjs from 'dayjs';
import Searchbox from '../../../components/inputs/searchbox';

const ProductHistoryFilters = ({ totalStockQuantity, filters, setFilters }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));

    const handleFilterChange = (event) =>
        setFilters({ [event.target.name]: event.target.value?.trim(), pageNumber: 1 });

    return (
        <Box component={Paper} padding={2}>
            <Grid container spacing={2}>
                <Grid
                    container
                    spacing={1}
                    size={{
                        xs: 12,
                        md: 8
                    }}
                >
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            lg: 4
                        }}
                    >
                        <Searchbox
                            fullWidth
                            size="small"
                            name="refId"
                            required
                            label="SKU del producto"
                            onChange={handleFilterChange}
                            value={filters?.refId || ""}
                        />
                    </Grid>
                    <Grid size={12}>
                        <Typography variant='inherit' color='primary'> Filtros adicionales </Typography>
                    </Grid>
                    <Grid
                        size={{
                            xs: 6,
                            lg: 4
                        }}
                    >
                        <DatePicker
                            label={filters?.from ? 'Desde' : 'dd/mm/aaaa'}
                            value={filters?.from ? dayjs(filters.from) : null}
                            onChange={(newValue) => {
                                handleFilterChange({
                                    target: {
                                        name: 'from',
                                        value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                    }
                                });
                            }}
                            format="DD/MM/YYYY"
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                actionBar: {
                                    onChange: (newValue) => {
                                        handleFilterChange({
                                            target: {
                                                name: 'from',
                                                value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                            },
                                        });
                                    },
                                    setOpen: (value) => {
                                        const picker = document.querySelector('[role="dialog"]');
                                        if (picker) picker.style.display = value ? 'block' : 'none';
                                    },
                                },
                                textField: {
                                    fullWidth: true,
                                    size: 'small',
                                },
                            }}
                        />
                    </Grid>
                    <Grid
                        size={{
                            xs: 6,
                            lg: 4
                        }}
                    >
                        <DatePicker
                            label={filters?.to ? 'Hasta' : 'dd/mm/aaaa'}
                            value={filters?.to ? dayjs(filters.to) : null}
                            onChange={(newValue) => {
                                handleFilterChange({
                                    target: {
                                        name: 'to',
                                        value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                    }
                                });
                            }}
                            format="DD/MM/YYYY"
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                actionBar: {
                                    onChange: (newValue) => {
                                        handleFilterChange({
                                            target: {
                                                name: 'to',
                                                value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                            },
                                        });
                                    },
                                    setOpen: (value) => {
                                        const picker = document.querySelector('[role="dialog"]');
                                        if (picker) picker.style.display = value ? 'block' : 'none';
                                    },
                                },
                                textField: {
                                    fullWidth: true,
                                    size: 'small',
                                },
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid
                    direction={!matches ? 'row' : 'column'}
                    container
                    spacing={1}
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    {!matches
                        ? <Divider variant="middle" orientation="vertical" flexItem />
                        : <Divider variant="middle" orientation="horizontal" flexItem />
                    }
                    <Grid container direction='column' justifyContent='center' size="grow">
                        <Typography variant="h6" align="center">
                            Stock Disponible
                        </Typography>
                        {
                            (!filters.refId) &&
                            <Typography variant="body1" align="center">
                                Esperando que se seleccione un producto
                            </Typography>
                        }
                        {
                            filters.refId && totalStockQuantity > 0 &&
                            <Typography variant="h6" align="center">
                                {totalStockQuantity}
                            </Typography>
                        }
                        {
                            filters.refId && totalStockQuantity <= 0 &&
                            <Typography variant="body1" align="center">
                                Sin stock en deposito
                            </Typography>
                        }

                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

export default ProductHistoryFilters;